import React, { useState } from "react";

export default ({ lista, height = 100, width = "fit-content", cabecalhoCentralizado = false, borderColor = "#22222250", backgroundColor = "", borderRadius }) => {
    const [linhaHover, setLinhaHover] = useState(null);
    return (
        <table
            style={{
                fontSize: "0.7rem",
                textWrap: "nowrap",
                lineHeight: 0,
                width,
                height,
                borderRadius,
            }}
        >
            <tbody>
                {lista
                    .filter((item) => !!item) //remove undefined
                    .map((item, i) => {
                        return (
                            <tr
                                key={i}
                                onMouseEnter={() => setLinhaHover(i)}
                                onMouseLeave={() => setLinhaHover(null)}
                                style={{
                                    color: linhaHover == i ? "#FFFFFF" : "",
                                    backgroundColor: linhaHover == i ? "#0000006e" : backgroundColor,
                                }}
                            >
                                {item.cabecalho ? (
                                    <td
                                        style={{
                                            border: `1px solid ${borderColor}`,
                                            padding: "0px 2px",
                                            height: height / lista.length,
                                            whiteSpace: "nowrap",
                                        }}
                                        rowSpan={i == 0 ? item.rowSpanCabecalho || 1 : 1}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: cabecalhoCentralizado ? "center" : "flex-start",
                                                height: "100%",
                                            }}
                                        >
                                            {item.cabecalho}
                                        </div>
                                    </td>
                                ) : null}

                                {item.valores ? (
                                    item.vertical ? (
                                        <td
                                            style={{
                                                border: `1px solid ${borderColor}`,
                                                width: 95,
                                                maxWidth: 95,
                                                padding: "0px 2px",
                                                height: 15 * item.valores.length,
                                            }}
                                        >
                                            {item.valores.map((valor, i) => (
                                                <div
                                                    key={i}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "start",
                                                        paddingLeft: 5,
                                                        height: 15,
                                                        width: "100%",
                                                        minWidth: 70,
                                                    }}
                                                >
                                                    {valor}
                                                </div>
                                            ))}
                                        </td>
                                    ) : (
                                        item.valores.map((valor, i) => (
                                            <td
                                                key={i}
                                                style={{
                                                    border: `1px solid ${borderColor}`,
                                                    width: item.widthValores || 75,
                                                    maxWidth: item.maxWidthValores || 75,
                                                    padding: "0px 2px",
                                                    height: height / lista.length,
                                                    verticalAlign: "middle",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        height: "100%",
                                                        width: "100%",
                                                        minWidth: (item.widthValores || 75) - 5,
                                                    }}
                                                >
                                                    {valor}
                                                </div>
                                            </td>
                                        ))
                                    )
                                ) : (
                                    <td
                                        style={{
                                            border: `1px solid ${borderColor}`,
                                            width: item.width || 75,
                                            maxWidth: item.width || 75,
                                            padding: "0px 2px",
                                            height: height / lista.length,
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                height: "100%",
                                                width: "100%",
                                                minWidth: 65,
                                            }}
                                        >
                                            {item.valor}
                                        </div>
                                    </td>
                                )}
                            </tr>
                        );
                    })}
            </tbody>
        </table>
    );
};
